import * as t from "io-ts";
import { DateFromISOString } from "io-ts-types";

export const Flag = t.intersection([
  t.type({
    level: t.union([t.literal("green"), t.literal("yellow"), t.literal("red")]),
  }),
  t.partial({
    aid: t.string,
    remark: t.string,
    flagged_at: DateFromISOString,
  }),
]);

export interface Flag {
  aid?: string;
  level: "green" | "yellow" | "red";
  remark?: string;
  flagged_at?: Date;
}
